import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'aum-cli-payment-password-confirmation',
  templateUrl: './payment-password-confirmation.component.html',
  styleUrls: ['./payment-password-confirmation.component.scss']
})
export class PaymentPasswordConfirmationComponent implements OnInit {
  form: FormGroup;
  isLoading = false;
  inputType = 'password';
  visible = false;
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; message: string },
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<PaymentPasswordConfirmationComponent>
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      password: new FormControl(null, [Validators.required])
    });
  }

  toggleVisibility() {
    if (this.visible) {
      this.inputType = 'password';
      this.visible = false;
    } else {
      this.inputType = 'text';
      this.visible = true;
    }
  }

  submitForm() {
    this.dialogRef.close(true);
  }
}
